import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {CustomerType} from "../../angular/types/customer-type.type";

export class CustomerSelectCtrl implements IController {

  selectedId: any;
  form: any;
  options: any;
  optionIds: any;
  name: string;
  ngPlaceholder: any;
  accountIds: string[];
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  allowGlobal: boolean;
  enableDisplayAllCustomers?: boolean;
  onChange: Function;

  private customersRef: any;
  public selectedCustomer: any;
  public selectedText: any;
  public customerTypes: typeof CustomerType = CustomerType;
  public inputName: any;

  /* @ngInject */
  constructor(private $mdPanel, private $customers, private $filter) {
    this.customersRef = this.$customers();
  }

  $onInit() {
    if (!this.name) {
      this.name = 'customerSelect';
    } else {
      this.inputName = this.name + 'Customer';
    }
    this._setSelectedCustomer();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelectedCustomer();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const accountIdsRef = this.accountIds;
    const allowGlobalRef = this.allowGlobal;
    const enableDisplayAllCustomersRef = this.enableDisplayAllCustomers;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'account-ids="ctrl.accountIdsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'customer';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.accountIdsRef = accountIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.queryMapRef = {
          allowGlobal: allowGlobalRef,
          enableDisplayAllCustomers: enableDisplayAllCustomersRef
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({customer: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const customer = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({customer: customer, id: selectedId});
            panel.destroy();
          } else {
            this.customersRef.$asyncValues([selectedId])
              .then((customers) => {
                this.onChange({customer: customers[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({customer: undefined});
  }

  private _setSelectedCustomer() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedCustomer = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.customersRef.$asyncValues([this.selectedId])
          .then((customers) => {
            this.selectedCustomer = _.orderBy(customers, ['firstName'], ['asc'])[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedCustomer = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    if(this.selectedCustomer?.type === this.customerTypes.Business){
      this.selectedText = this.selectedCustomer.businessName
    } else {
      this.selectedText = this.selectedCustomer ? this.$filter('userName')(this.selectedCustomer) : '';
    }
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      name: '@?',
      accountIds: '<?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      allowGlobal: '<?',
      enableDisplayAllCustomers: '<?',
      onChange: '&'
    },
    template: require('./customer-select.html').default,
    controller: CustomerSelectCtrl
  });
